/**
 * The fixed Field Notes series ramp (DESIGN.md §2): forest → moss →
 * rust → warn → line-strong, in that order, no extra hues.
 *
 * One source for all three utility families so a chart's `fill-*`,
 * `stroke-*` and `bg-*` spellings cannot drift apart — `StackedBars`
 * cycles them, `Line` derives its closed prop unions from them, and
 * `test/charts.test.ts` checks every slot against a real
 * `src/ui/tokens.ts` color. That check is the only thing standing
 * between a typo and silence: a well-FORMED but non-existent utility
 * class produces no error and no style.
 *
 * The arrays MUST stay slot-for-slot mirrors, and each entry MUST be a
 * whole class literal — never a `prefix-${token}` template — because
 * Tailwind's content scanner only picks up complete class strings.
 */

export const CHART_FILL_RAMP = [
  'fill-forest',
  'fill-moss',
  'fill-rust',
  'fill-warn',
  'fill-line-strong',
] as const;

export const CHART_STROKE_RAMP = [
  'stroke-forest',
  'stroke-moss',
  'stroke-rust',
  'stroke-warn',
  'stroke-line-strong',
] as const;

export const CHART_SWATCH_RAMP = [
  'bg-forest',
  'bg-moss',
  'bg-rust',
  'bg-warn',
  'bg-line-strong',
] as const;

export type ChartFillClass = (typeof CHART_FILL_RAMP)[number];
export type ChartStrokeClass = (typeof CHART_STROKE_RAMP)[number];
